/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseOfString } from '../../models/api-response-of-string';

export interface RolesDelete$Params {
  Roleid: number;
}

export function rolesDelete(http: HttpClient, rootUrl: string, params: RolesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
  const rb = new RequestBuilder(rootUrl, rolesDelete.PATH, 'delete');
  if (params) {
    rb.path('Roleid', params.Roleid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseOfString>;
    })
  );
}

rolesDelete.PATH = '/api/Roles/{Roleid}';
